import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const SpeedIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 26.5 26.5"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 26.5)}
      {...svgProps}
    >
      <g
        fill="none"
        stroke={color ?? "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <circle cx="13.25" cy="13.25" r="12.5" />
        <circle cx="13.25" cy="12.417" r="1.667" />
        <path d="m18.25 19.084a1.667 1.667 0 0 1 -1.667 1.667h-6.666a1.667 1.667 0 1 1 0-3.333h6.667a1.667 1.667 0 0 1 1.666 1.666z" />
        <path d="m10.114 3.803.57 1.566" />
        <path d="m5.311 7.833 1.443.833" />
        <path d="m4.222 14.009 1.642-.29" />
        <path d="m16.386 3.803-.57 1.566" />
        <path d="m21.189 7.833-6.496 3.75" />
        <path d="m22.278 14.009-1.642-.29" />
      </g>
    </SVG>
  );
};
